import React, { useCallback, useEffect, useState } from 'react';
import { listOturumlar, revokeOturum, logoutAllDevices } from '../services/sessionService';
import { logout as authLogout } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';

function formatDate(value) {
  try {
    return new Date(value).toLocaleString('tr-TR');
  } catch {
    return value;
  }
}

export default function OturumlarPage() {
  const { logout } = useAuth();
  const [oturumlar, setOturumlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await listOturumlar();
      setOturumlar(res?.veri?.oturumlar || []);
    } catch (e) {
      setError(e?.message || 'Oturumlar yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleRevoke = async (sessionId) => {
    if (!window.confirm('Bu cihazdaki oturumu kapatmak istiyor musunuz?')) return;
    setBusyId(sessionId);
    try {
      await revokeOturum(sessionId);
      await load();
    } catch (e) {
      window.alert(e?.message || 'İşlem başarısız');
    } finally {
      setBusyId('');
    }
  };

  const handleLogoutOthers = async () => {
    if (!window.confirm('Bu cihaz hariç tüm oturumlar kapatılacak. Devam edilsin mi?')) return;
    setBusyId('all');
    try {
      await logoutAllDevices();
      await load();
    } catch (e) {
      window.alert(e?.message || 'İşlem başarısız');
    } finally {
      setBusyId('');
    }
  };

  const handleLogoutAll = async () => {
    if (!window.confirm('Tüm cihazlardan çıkış yapılacak. Devam edilsin mi?')) return;
    try {
      await logoutAllDevices();
      await authLogout();
      await logout();
    } catch (e) {
      window.alert(e?.message || 'Çıkış başarısız');
    }
  };

  return (
    <div className="page-container">
      <div className="content-header">
        <div>
          <h1>Aktif Oturumlar</h1>
        </div>
      </div>

      {loading ? (
        <p>Yükleniyor…</p>
      ) : error ? (
        <div className="alert alert-error">
          <p>{error}</p>
          <button type="button" className="btn btn-secondary" onClick={load}>
            Tekrar dene
          </button>
        </div>
      ) : (
        <div className="oturumlar-list">
          {oturumlar.map((o) => (
            <div key={o.sessionId} className="oturumlar-card card">
              <div className="oturumlar-card__head">
                <strong>{o.deviceName}</strong>
                {o.isCurrentSession ? <span className="oturumlar-badge">Bu cihaz</span> : null}
              </div>
              <p className="text-muted">
                {o.platform} · {o.model || o.brand || '—'}
              </p>
              <p className="text-muted">Son kullanım: {formatDate(o.lastUsedAt)}</p>
              {!o.isCurrentSession ? (
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  disabled={busyId === o.sessionId}
                  onClick={() => handleRevoke(o.sessionId)}
                >
                  {busyId === o.sessionId ? 'Kapatılıyor…' : 'Oturumu kapat'}
                </button>
              ) : null}
            </div>
          ))}

          <div className="oturumlar-actions">
            {oturumlar.some((o) => !o.isCurrentSession) ? (
              <button
                type="button"
                className="btn btn-secondary"
                disabled={busyId === 'all'}
                onClick={handleLogoutOthers}
              >
                Diğer tüm cihazlardan çık
              </button>
            ) : null}
            <button type="button" className="btn btn-danger" onClick={handleLogoutAll}>
              Tüm cihazlardan çıkış yap
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
